export const SET_VENDOR_PAGE_SIZE = "SET_VENDOR_PAGE_SIZE";

export const SET_VENDOR_SEARCH_INPUT = "SET_VENDOR_SEARCH_INPUT";

export const SET_VENDOR_CURRENT_PAGE = "SET_VENDOR_CURRENT_PAGE";

export const GET_VENDOR_DATA_START = "GET_VENDOR_DATA_START";
export const GET_VENDOR_DATA_SUCCESS = "GET_VENDOR_DATA_SUCCESS";
export const GET_VENDOR_DATA_FAIL = "GET_VENDOR_DATA_FAIL";

export const FETCH_VEHICLE_DETAILS_START = "FETCH_VEHICLE_DETAILS_START";
export const FETCH_VEHICLE_DETAILS_SUCCESS = "FETCH_VEHICLE_DETAILS_SUCCESS";
export const FETCH_VEHICLE_DETAILS_FAIL = "FETCH_VEHICLE_DETAILS_FAIL";
export const RESET_VEHICLE_DETAILS = "RESET_VEHICLE_DETAILS";

export const GENERATE_INVOICE_START = "GENERATE_INVOICE_START";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";
export const GENERATE_INVOICE_FAIL = "GENERATE_INVOICE_FAIL";

export const FETCH_INVOICE_HISTORY_START = "FETCH_INVOICE_HISTORY_START";
export const FETCH_INVOICE_HISTORY_SUCCESS = "FETCH_INVOICE_HISTORY_SUCCESS";
export const FETCH_INVOICE_HISTORY_FAIL = "FETCH_INVOICE_HISTORY_FAIL";

export const SET_INVOICE_FILTERS = "SET_INVOICE_FILTERS";
export const SET_INVOICE_HISTORY_CURRENT_PAGE = "SET_INVOICE_HISTORY_CURRENT_PAGE";
export const SET_INVOICE_HISTORY_PAGE_SIZE = "SET_INVOICE_HISTORY_PAGE_SIZE";
export const SET_INVOICE_HISTORY_DOCUMENT_TYPE = "SET_INVOICE_HISTORY_DOCUMENT_TYPE";
